export interface DSIKPISettingsProps {
  kpi_path: string;
  kpi: string;
  label?: string;
  unit?: string;
  colorKey?: string;
  configurable?: boolean;
  hasTotal?: boolean;
  filter?: (item?: Record<string, unknown>) => boolean;
  formatObj?: (item?: Record<string, unknown>) => Record<string, unknown> | undefined;
  [key: string]: unknown;
}

/** this is used for the api call, it will return aggregated data based on what you send.   */
export const kpiTypes = [
  /** this won't apply */
  'Aggregate', 
  /** returns a timestamp each hour in range */
  'Hours', 
  /** returns a timestamp every 30 minutes in range */
  '30_Minutes', 
  /** returns a timestamp every 15 minutes in range */
  '15_Minutes', 
  /** returns a timestamp every minute in range */
  'Minutes'
]

export const yield_kpi = {
  kpi_path: 'yield',
  kpi: 'yield',
  label: 'product yield',
  // filter: (item?: Record<string, unknown>) =>  Number(item?.value) > 0 && Number(item?.value) < 100,
  slider_range: true,
  slider_percentage: true,
}

export const throughput_rate = {
  kpi_path: 'throughput-rate',
  kpi: 'throughput_rate',
  label: 'throughput rate',
  hasTotal: true,
  slider_range: true,
  hasInput : ['Volume','Lbs/ hr'],
  maxVal: 50000
}

export const gross_yield = {
  kpi_path: 'gross-yield',
  kpi: 'gross_yield',
  label: 'gross yield',
  slider_percentage: true,
}

export const belt_speed = {
  kpi_path: 'belt-speed',
  kpi: 'belt_speed',
  label: 'belt speed',
  hasTarget: false,
  hasTotal: false,
  hasInput : ['Speed','Feet per Minute']
 }

export const processed_product_percentage = {
  kpi_path: 'processed-product-percentage',
  kpi: 'processed_product_percentage',
  label: 'processed product percentage',
  slider_range: true,
  slider_percentage: true,
}

const infeed_piece_size = {
  kpi_path: 'infeed-piece-size',
  kpi: 'infeed_piece_size',
  label: 'infeed piece size',
  hasInput : ['Size','Grams']
}

export const throughput_piece_count = {
  kpi_path: 'throughput-piece-count',
  kpi: 'throughput_piece_count',
  label: 'throughput piece count',
  hasTotal: true,
  slider_range: true,
  hasInput : ['Pieces','Pcs/ min']
}

const output_piece = {
  kpi_path: 'output-piece',
  kpi: 'output_piece',
  label: 'output piece',
  hasInput : ['Pieces','Pcs/ min']
 }

const portion1_conversion = {
  kpi_path: 'portion1-conversion',
  kpi: 'portion1_conversion',
  label: 'conversion portion rate',
  slider_percentage: true,
}

const output_weight = {
  kpi_path: 'output-weight',
  kpi: 'output_weight',
  label: 'output weight',
  hasInput : ['Pieces','Lbs/ hr']
   /*
  // leaving this for another dev for reference 
  formatObj: (item?: Record<string, unknown>): Record<string, unknown> => ({
    ...item,
    value: Number(item?.value || 0) * 60
  }),
  */
 
}

export const loading_gap = {
  kpi_path: 'loading-gap',
  kpi: 'gap',
  label: 'loading gap',
  colorKey: 'length',
  hasInput : ['Gap','mm']
}

export const kpis = {
  processed_product_percentage,
  yield: yield_kpi,
  gross_yield,
  belt_speed,
  loading_gap,
  throughput_rate,
  throughput_piece_count,
  output_piece,
  infeed_piece_size,
  output_weight,
  portion1_conversion  
}

export const allKpis =  Object.values(kpis) as DSIKPISettingsProps[] //[throughput_piece_count]